import React, { useState } from "react";
import { CardElement, Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { Alert, Button, Col, Row } from "react-bootstrap";
import { saveStripePaymentMethod } from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { loadStripe, StripeCardElement } from "@stripe/stripe-js";
import { AppState } from "../redux/types";
import { getStripeLocale } from "../utils/currency";

export default function CheckoutForm(params: any) {
    const regionCode = useSelector((state: AppState) => state.region?.code ?? "FI");
    const [stripePromise] = useState(loadStripe(params.stripePublicKey, { locale: getStripeLocale(regionCode) as any }));
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm2 setSPM={params.setSPM} handleForm={params.handleForm} handleBack={params.handleBack} />
        </Elements>
    );
}

const ELEMENT_OPTIONS = {
    style: {
        base: {
            fontSize: "18px",
            color: "#424770",
            letterSpacing: "0.025em",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#9e2146",
        },
    },
    hidePostalCode: true,
};

function CheckoutForm2(params: any) {
    const stripe = useStripe();
    const elements = useElements();
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState("");
    const user = useSelector((state: AppState) => state.user);
    const dispatch = useDispatch();

    function stripePaymentMethodHandler(result: any, event: any) {
        if (result.error) {
            setError(result.error.message);
            // params.reload_subscriptions();
            setProcessing(false);
        } else {
            // Otherwise send paymentMethod.id to your server
            setProcessing(false);
            dispatch(saveStripePaymentMethod(result.paymentMethod.id));
            params.setSPM(result.paymentMethod.id);
            params.handleForm(event);
        }
    }

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setError("");
        setProcessing(true);
        if (!stripe || !elements) {
            return;
        }
        try {
            let result = await stripe.createPaymentMethod({
                type: "card",
                card: elements.getElement(CardElement) as StripeCardElement,
                billing_details: {
                    name: user.id ? `${user.firstName} ${user.lastName}` : "guest",
                    email: user.email || "digihappy@mediti.fi",
                },
            });
            stripePaymentMethodHandler(result, event);
        } catch (err: any) {
        }
    };

    return (
        <form className="my-3">
            <div className="my-4 p-3" style={{ border: "1px solid #ced4da", borderRadius: "0.25rem", background: "#fff" }}>
                <CardElement options={ELEMENT_OPTIONS} />
            </div>
            {error && <Alert variant="danger">{error}</Alert>}
            <Row className="justify-content-md-center my-4">
                <Col xs={6}>
                    <Button type="button" className="tallenna paymentmethod-back-button" onClick={params.handleBack}>
                        Takaisin
                    </Button>
                </Col>
                <Col xs={6} className="text-right">
                    <Button
                        className="tallenna"
                        type="button"
                        disabled={!stripe || processing}
                        onClick={handleSubmit}
                    >
                        Seuraava
                    </Button>
                </Col>
            </Row>
        </form>
    );
}
